import React, { useState } from "react";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Col,
  Typography,
  Card,
  Form,
  Checkbox,
  Popconfirm,
  Divider,
  Radio,
  Button,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { DownOutlined, RightOutlined, CloseOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import data from "../../../../../src/config/data/LoanProductFormData.json";
import EditableTable from "../../FixedDeposits/EditableTable";

const { Text, Title } = Typography;

export const AccountingForm = (props) => {
  const { fixedDepositDetails } = props;

  const [formData, setFormData] = useState({ account: data[5] });

  const [form] = Form.useForm();
  const [showAdvancedAccounting, setShowAdvancedAccounting] = useState(false);
  const [dataSource, setDataSource] = useState([
    {
      key: "0",
      paymentType: "Edward King 0",
      fundSource: "32",
    },
    {
      key: "1",
      paymentType: "Edward King 1",
      fundSource: "32",
    },
  ]);

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };

  const onFinishAccountForm = (values) => {
    console.log(values);
    setFormData({ ...formData, account: values });
  };

  const defaultColumns = [
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      width: "30%",
      //   editable: true,
    },
    {
      title: "Fund Source",
      dataIndex: "fundSource",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <CloseOutlined
              style={{
                color: "#92428B",
                fontSize: "15px",
                fontWeight: "bolder",
              }}
            />
          </Popconfirm>
        ) : null,
    },
  ];

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        padding: 10,
      }}
    >
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {"  Assets"}
        </Title>
      </Divider>
      <Row>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong> Deposit Reference</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                fixedDepositDetails?.accountingMappings?.savingsReferenceAccount
                  ?.name ?? null
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {"Liabilities"}
        </Title>
      </Divider>
      <Row>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Savings Control</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                fixedDepositDetails?.accountingMappings?.savingsControlAccount
                  ?.name
              }
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label={<Text strong>Transfers In Suspense</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                fixedDepositDetails?.accountingMappings
                  ?.transfersInSuspenseAccount?.name
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {"Expenses"}
        </Title>
      </Divider>
      <Row>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Interest On Deposits</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                fixedDepositDetails?.accountingMappings
                  ?.interestOnSavingsAccount?.name
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {"Income"}
        </Title>
      </Divider>
      <Row>
        <Col span={12}>
          <Form.Item label={<Text strong>Income From Fees</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                fixedDepositDetails?.accountingMappings?.incomeFromFeeAccount
                  ?.name
              }
            />
          </Form.Item>
        </Col>

        <Col span={12} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Income From Penalties</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                fixedDepositDetails?.accountingMappings
                  ?.incomeFromPenaltyAccount?.name
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Title level={4}>
        Advanced Accounting Rule:{" "}
        <span>
          {showAdvancedAccounting ? (
            <>
              <Button
                type="dashed"
                onClick={() =>
                  setShowAdvancedAccounting(!showAdvancedAccounting)
                }
                icon={<DownOutlined />}
              >
                Hide
              </Button>
            </>
          ) : (
            <>
              <Button
                type="dashed"
                onClick={() =>
                  setShowAdvancedAccounting(!showAdvancedAccounting)
                }
                icon={<RightOutlined />}
              >
                Show
              </Button>
            </>
          )}
        </span>
      </Title>
      <Divider style={{ margin: 0, padding: 0 }} />
      {showAdvancedAccounting && (
        <div>
          {/* <EditableTable
            source1={"Payment Type"}
            source2={"Fund Source"}
            tableTitle={"Configure Fund Sources for Payment Channels "}
            defaultColumns={defaultColumns}
            handleDelete={handleDelete}
            dataSource={dataSource}
            setDataSource={setDataSource}
          /> */}

          {/* <EditableTable
            source1={"Payment Type"}
            source2={"Fund Source"}
            tableTitle={"Map Fees to Income Accounts"}
            defaultColumns={defaultColumns}
            handleDelete={handleDelete}
            dataSource={dataSource}
            setDataSource={setDataSource}
          /> */}

          {/* <EditableTable
            source1={"Payment Type"}
            source2={"Fund Source"}
            tableTitle={"Map Penalties to Specific Income Accounts "}
            defaultColumns={defaultColumns}
            handleDelete={handleDelete}
            dataSource={dataSource}
            setDataSource={setDataSource}
          /> */}
        </div>
      )}
    </Card>
  );
};
